type DefaultObjectType = {
  [key: string]: string;
};

export const PLUS_BAR_BUTTON_TEXT_SUB_GROUP_SHELL: DefaultObjectType = {
  "Milestone Payment And Detail": "MILESTONE",
  "Other Payment And Detail": "OTHER PAYMENT",
  "Royalty(LA&SC)": "ROYALTY",
  "Partner A": "PARTNER A",
  "Partner B": "PARTNER B",
  "Partner C": "PARTNER C",
  Advisor: "ADVISOR",
};
